// react/src/hooks/useUserCsvUploads.ts

import axios from 'axios';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useQuery } from 'react-query';

const fetchUserCsvUploads = async (
  _key: string,
  partnerId: number
) => {
  // You could add pagination if desired.
  // For simplicity, just fetch them all in descending order of creation.
  const { data } = await axios.get(`/api/v3/partners/${partnerId}/user_csv_uploads`);
  return data;
};

export const useUserCsvUploads = () => {
  const user = useCurrentUser();
  const partnerId = user?.primaryPartner?.id;

  return useQuery(
    ['userCsvUploads', partnerId],
    fetchUserCsvUploads,
    {
      enabled: !!partnerId,
      // For a simple, ongoing poll, do something like:
      refetchInterval: 60000, // poll every 60 seconds
    }
  );
};
